<template>
  <div
    class="painterSubmit"
    v-if="judgeBox"
  >
    <div class="form__title form-field md20">
      <div class="form-field__title is-required">标题</div>
      <div class="form-field__content">
        <div class="form-field__input">
          <input
            type="text"
            :placeholder="formData.title.placeholder"
            v-model="title"
            :maxlength="formData.title.maxlength"
            @change="validateText({name: 'title'})"
            ref="titleInputRef"
          />
          <span class="form-field__tip">{{formData.title.value.length}}/{{formData.title.maxlength}}</span>
        </div>
        <div
          class="form-field__valid-tip"
          v-show="titleFail"
        >{{formData.title.validTip}}</div>
      </div>
    </div>

    <div
      class="form__tags form-field md20"
      v-if="judgeFrom.label"
    >
      <div
        class="form-field__title"
        :class="{'is-required': formData.tags.isRequired}"
      >标签</div>
      <div class="form-field__content">
        <div
          class="form-field__tag"
          v-for="(tag, i) in formData.tags.items"
          :key="i"
          @mouseenter="onMouseEnterTag(tag, i)"
          @mouseleave="onMouseLeaveTag(tag, i)"
        >
          <span>{{tag.text}}</span>
          <i
            v-show="tag.hover"
            @click="removeTag(i)"
            class="remove el-icon-circle-close"
          ></i>
        </div>
        <div
          class="form-field__input"
          v-show="formData.tags.isShowInput"
        >
          <!-- <el-tooltip effect="dark" :content="formData.tags.placeholder" placement="top"> -->
          <input
            type="text"
            :maxlength="formData.tags.maxlength"
            :placeholder="getTagsPlaceholder(tagsCountMax)"
            v-model="formData.tags.value"
            :disabled="formData.tags.disabled"
            @keyup.enter="onBlurTagInput()"
            @change="pushTag()"
            @blur="onBlurTagInput()"
            @input="valiateTagInput()"
            ref="tagsInputRef"
          />
          <!-- </el-tooltip> -->
        </div>
        <div
          class="form-field__valid-tip"
          v-show="!formData.tags.forceHidden && formData.tags.validFail"
        >{{formData.tags.validTip}}</div>
      </div>
    </div>

    <div class="form__desc form-field md40">
      <div
        class="form-field__title is-top"
        :class="{'is-required': formData.tags.isRequired}"
      >简介</div>
      <div class="form-field__content">
        <div class="form-field__textarea">
          <textarea
            :placeholder="formData.desc.placeholder"
            v-model="desc"
            :maxlength="150"
            @change="validateText({name: 'desc'})"
            ref="descInputRef"
            @blur="onDescBlur()"
          ></textarea>
          <span class="form-field__tip">{{desc.length}}/{{150}}</span>
        </div>
        <div
          class="form-field__valid-tip"
          v-show="descFail"
        >{{formData.desc.validTip}}</div>
      </div>
    </div>

    <div
      class="form__desc form-field md40"
      v-if="judgeFrom.combinationPrice"
      style="
            transform: translatex(0px);
            width: 527px;
            height: 40px;
            justify-content: left;
          "
    >
      <div class="form-field__title is-required">类型</div>
      <div class="form-field__content">
        <div
          style="margin-right: 30px; width: 50px;"
          @click="combination = 'text'"
        >
          <span class="payTypeBtn">
            <span
              :class="{
                      'payTypeBtnActive' : combination == 'text'
                    }"
            ></span>
          </span>
          文字
        </div>

        <div
          @click="combination = 'prop'"
          style="margin-right: 30px; width: 50px;"
        >
          <span class="payTypeBtn">
            <span
              :class="{
                      'payTypeBtnActive' : combination == 'prop'
                    }"
            ></span>
          </span>
          道具
        </div>

        <div
          @click="combination = 'shape'"
          style="margin-right: 30px; width: 50px;"
        >
          <span class="payTypeBtn">
            <span
              :class="{
                      'payTypeBtnActive' : combination == 'shape'
                    }"
            ></span>
          </span>
          形状
        </div>
      </div>
    </div>

    <div
      class="form__desc form-field md40"
      v-if="StyleArrayMsg && judgeFrom.videoStyle"
    >
      <div
        class="form-field__title is-required"
        :class="{'is-required': formData.tags.isRequired}"
      >风格</div>
      <div class="form-field__content">
        <div
          class="submitLabel"
          v-for="item,index in StyleArrayMsg"
          :key="index"
          :class="{
                        'submitLabelActive' : index == 0,
                    }"
          @click="setLabelStyle(item.id, $event)"
        >{{item.name}}</div>
      </div>
    </div>

    <div
      class="form__desc form-field md40"
      v-if="StyleArrayMsg && judgeFrom.combinationStyle"
    >
      <div
        class="form-field__title is-required"
        :class="{'is-required': formData.tags.isRequired}"
      >风格</div>
      <div class="form-field__content">
        <div
          class="submitLabel"
          v-for="item,index in StyleArrayMsg"
          :key="index"
          :class="{
            'submitLabelActive' : combinationStyle == item.id,
          }"
          @click="setLabelStyle(item.id, $event)"
        >{{item.name}}</div>
      </div>
    </div>

    <div
      class="form__desc form-field md40"
      style="
            transform: translatex(0px);
            width: 527px;
            height: 40px;
            justify-content: left;
          "
      v-if="StyleArrayMsg && judgeFrom.combinationCategories"
    >
      <div
        class="form-field__title is-required"
        :class="{'is-required': formData.tags.isRequired}"
      >分类</div>
      <div
        class="form-field__content combination"
        style="flex-wrap: wrap; padding-top: 20px;"
      >
        <div
          class="submitLabel"
          v-for="item,index in this.categories.business"
          :key="index"
          :class="{
                      'submitLabelActive' : index == 0,
                  }"
          @click="setCategories(item.id, $event)"
        >{{item.name}}</div>
      </div>
    </div>

    <template v-if="TopnavMsg.transferData.type === 'template'">
      <div class="form__desc form-field md40" v-if="StyleArrayMsg && judgeFrom.videoCategories">
        <div
          class="form-field__title"
          :class="{'is-required': true}"
        >一级分类</div>
        <div
          class="form-field__content"
          style="flex-wrap:wrap;width: 400px;"
        >
          <multi-selector
            :selectorLabel="'level-1'"
            :optionItems="templateCates"
            :selectedLabels="filterSelectedLabels(templateSelectedCates, templateCates)"
            @selectOption="onSelectTemplateCate"
            @removeSelected="onRemoveTemplateCate"
          ></multi-selector>
        </div>
      </div>
      <div class="form__desc form-field md40" v-if="templateSelectedCates && templateSelectedCates.length" style="display: block;">
        <div
          class="form-field__title template-child-cates"
          :class="{'is-required': true}"
          style="margin-left: -20px;margin-bottom: 16px;"
        >选择二级分类</div>
        <div class="child-cate-row" v-for="v, i in childCateTable" :key="i">
          <div class="child-cate-text">{{getTemplateCateText(i)}}</div>
          <multi-selector
            v-if="v"
            :selectorLabel="i"
            :optionItems="v.optionItems"
            :selectedLabels="filterSelectedLabels(templateSelectedCates, v.optionItems)"
            @selectOption="onSelectTemplateCate"
            @removeSelected="onRemoveTemplateCate"
          ></multi-selector>
        </div>
      </div>
    </template>
    <div class="my-test" :data="TopnavMsg.transferData.type"></div>
    <div
      class="form__desc form-field md40"
      v-if="StyleArrayMsg && judgeFrom.videoCategories && TopnavMsg.transferData.type !== 'template'"
    >
      <div
        class="form-field__title is-required"
        :class="{'is-required': formData.tags.isRequired}"
      >分类</div>
      <div
        class="form-field__content"
        style="flex-wrap: wrap; padding-top: 20px;"
      >
        <span class="submitLabelTitle">商业</span>

        <div
          class="submitLabel"
          v-for="item,index in this.categories.business"
          :key="index"
          :class="{
            'submitLabelActive' : index == 0,
          }"
          @click="setCategories(item.id, $event)"
        >{{item.name}}</div>
      </div>
    </div>

    <div
      class="form__desc form-field md40"
      v-if="StyleArrayMsg && judgeFrom.videoCategories && TopnavMsg.transferData.type !== 'template'"
    >
      <div
        class="form-field__content"
        style="flex-wrap: wrap; padding-left: 27px; padding-top: 20px;"
      >
        <span
          class="submitLabelTitle"
          style="
                  left : 27px;
                "
        >个人</span>

        <div
          class="submitLabel"
          v-for="item in this.categories.personal"
          @click="setCategories(item.id, $event)"
        >{{item.name}}</div>
      </div>
    </div>

    <div
      class="form__desc form-field md40"
      v-if="judgeFrom.videoPrice && TopnavMsg.transferData.type === 'combination'"
      style="
            transform: translatex(0px);
            width: 527px;
            height: 40px;
            justify-content: left;
          "
    >
      <div
        class="form-field__title is-required"
        :class="{'is-required': formData.tags.isRequired}"
      >价格</div>
      <div
        class="form-field__content"
        style="width: 150px;"
      >
        <div
          style="margin-right: 30px;"
          @click="payTypeFS('payType', 0)"
        >
          <span class="payTypeBtn">
            <span
              ref="payTypeBtnActive_two"
              class="payTypeBtnActive"
            ></span>
          </span>
          免费
        </div>

        <div @click="payTypeFS('payType', 1)">
          <span class="payTypeBtn">
            <span ref="payTypeBtnActive_one"></span>
          </span>
          付费
        </div>
      </div>
      <div
        v-if="payType == 1"
        class="form-field__input"
        style="width: 214px;height: 40px;"
      >
        <input
          type="text"
          placeholder="建议在1-100以内的整数（元）"
          v-model="price"
          ref="titleInputRef"
        />
      </div>
    </div>

    <div
      class="form__desc form-field md40 template-game-container"
      v-if="false && templateGames && templateGames.length && UserMsg.type === 2"
    >
      <div class="form-field__title template-game-key">活动</div>
      <div
        class="form-field__content template-game"
        style="display: block;"
      >
        <template v-for="(v, k) in templateGames">
          <div
            class="template-game-item"
            :key="k"
          >
            <el-checkbox v-model="v.checked">
              <span>{{v.title}}</span>
              <a
                v-if="v.url"
                class="template-game-link"
                @click.stop
                :href="v.url"
                target="_blank"
              >
                <span>(了解详情)</span>
              </a>
            </el-checkbox>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import multiSelector from '../multiSelector/selectorContainer.vue'
const DESC = '由来画动画提供,丰富MG动画素材,短视频制作模板,免费在线制作动画短视频。来画动画,动画短视频云端智能创作平台。';

export default {
  components: {
    multiSelector
  },
  model: {
    prop: 'formData',
    event: 'updataformData'
  },
  data () {
    return {
      categories: {
        business: [],
        personal: []
      },
      payType: 0,
      price: '',
      judgeFrom: {
        label: true,
        videoPrice: true,
        videoCategories: true,
        videoStyle: true,
        combinationPrice: false,
        combinationCategories: false,
        combinationStyle: false
      },
      combination: 'text',
      combinationStyle: '',
      templateGames: null,
      title: '',
      desc: '',
      titleFail: false,
      descFail: false,
      templateCatesFail: false,
      tagsCountMax: 20,
      templateCates: [],
      templateSelectedCates: [],
      childCateTable: {},
      StyleArrayMsg: []
    };
  },
  computed: {
    ...mapGetters(['TopnavMsg', 'GameList', 'UserMsg', 'TOOL', 'StyleMsg']),
    templateType () {
      return this.TopnavMsg.transferData.platform === 2 ? 'app' : 'web';
    },
    submitInvalid () {
      console.log(`Turbo ~ submitInvalid ~ this.titleFail:`, this.titleFail)
      console.log(`Turbo ~ submitInvalid ~ this.templateCatesFail:`, this.templateCatesFail)
      return this.titleFail || this.templateCatesFail;
    }
  },
  props: ['formData', 'descLength', 'judgeBox'],
  watch: {
    GameList () {
      this.handleGames();
    },
    judgeBox: function () {
      this.onJudgeBox();
    },
    price () {
      this.payTypeFS('price', this.price);
    },
    combination: {
      immediate: true,
      handler () {
        this.getCategories();
        this.formData.combinationType = this.combination;
        this.$emit('updataformData', this.formData);
      }
    },
    // combination: function () {
    //   this.getCategories();
    //   this.formData.combinationType = this.combination;
    //   this.$emit('updataformData', this.formData);
    // },
    combinationStyle: function () {
      this.getCategories();
    },
    title (val) {
      // if (this.$refs.descInputRef && document.activeElement === this.$refs.descInputRef) {
      //   return;
      // }
      this.desc = val + DESC;
      this.validateText({name: 'title'});
    },
    desc (val) {
      // this.title = val.replace(/是由[\s\S]*$/, '');
      this.validateText({name: 'desc'});
    },
    templateSelectedCates: {
      immediate: true,
      handler () {
        const valid = this.validateTemplateCates();
        console.log(`Turbo ~ handler ~ this.TopnavMsg.transferData.type:`, this.TopnavMsg.transferData.type)
        this.templateCatesFail = !valid;
      }
    },
    submitInvalid: {
      immediate: true,
      handler (val) {
        this.$parent.$parent.templateInvalid = val;
      }
    }
  },
  created () {
    this.$bus.on('getTemplateGames', templateGames => {
      const games = this.templateGames || [];
      templateGames.ids = (games.filter(v => v.checked) || []).map(
        v => v.id
      );
    });

    this.desc = this.formData.title.value + DESC;
    this.title = this.formData.title.value;

    this.onJudgeBox();
  },
  mounted () {
    this.validateFields();
  },
  methods: {
    onJudgeBox() {
      if (this.judgeBox) {
        this.onViewShow();
      } else {
        (this.formData.labelStyle = []), // 发布style标签
          (this.formData.categories = []), // 发布style分类的标签
          (this.formData.payType = 0), // 0、1，0：免费，1：收费
          (this.formData.price = 0), // 金额
          (this.formData.combinationType = 'text'), // 组合类型
          this.$emit('updataformData', this.formData);
        this.payType = 0;
        this.price = '';
        this.judgeFrom.label = true;
        this.judgeFrom.videoPrice = true;
        this.judgeFrom.videoCategories = true;
        this.combinationStyle = '';
      }
    },
    onDescBlur () {
      this.title = this.desc.replace(/由[\s\S]*$/, '');
    },
    validateText (data) {
      // this.$emit('validateText', data);
      if (data.name === 'desc') {
        this.descFail = !this.desc.length;
      }
      if (data.name === 'title') {
        this.titleFail = !this.title.length;
      }
    },
    onMouseEnterTag (data, i) {
      this.$emit('onMouseEnterTag', data, i);
    },
    onMouseLeaveTag (data, i) {
      this.$emit('onMouseLeaveTag', data, i);
    },
    removeTag (i) {
      this.$emit('removeTag', i);
    },
    onBlurTagInput () {
      this.$emit('onBlurTagInput');
    },
    pushTag () {
      this.$emit('pushTag');
    },
    valiateTagInput () {
      this.$emit('valiateTagInput');
    },
    setLabelStyle (data, el) {
      let index = this.searchDataIndex(this.formData.labelStyle, data);
      if (index == -1) {
        switch (this.TopnavMsg.transferData.type) {
          case 'combination':
            this.formData.labelStyle = [];
            this.$emit('updataformData', this.formData);
            this.formData.labelStyle.push(data);
            this.combinationStyle = data;
            break;
          default:
            this.formData.labelStyle.push(data);
            if (el) {
              el.target.classList.add('submitLabelActive');
            }
        }
      } else {
        switch (this.TopnavMsg.transferData.type) {
          case 'combination':
            break;
          default:
            if (this.formData.labelStyle.length > 1) {
              this.formData.labelStyle.splice(index, 1);
              if (el) {
                el.target.classList.remove('submitLabelActive');
              }
            }
        }
      }
      this.$emit('updataformData', this.formData);
    },
    getCategories () {
      if (this.TopnavMsg.transferData.type === 'combination') {
        this.getCombinationCates();
      } else {
        this.templateType === 'app' ? this.getAppTemplateCates() : this.getTemplateCates();
      }
    },
    async getAppTemplateCates () {
      const {data: resp} = await this.$http.get('/api/categoryInfo', {
        params: {
          isPass: 1,
        }
      });
      if (resp.code === 200) {
        let cates = resp.data || [];
        cates = cates.map(async v => {
          const {data: childResp} = await this.$http.get('/api/categoryInfo', {
            params: {
              isPass: 1,
              pid: v.id
            }
          });
          return {label: v.id, text: v.name, data: childResp.data};
        });
        cates = await Promise.all(cates);
        this.templateCates = cates;
      }
    },
    getTemplateCates () {
      let datatype = {
        isPass: 1,
        type: 8,
        // style: this.StyleMsg
      };
      this.$http
        .get('/api/home/category', {
          params: datatype
        })
        .then(res => {
          if (res.data && res.data.code === 200) {
            const list = [];
            const dict = res.data.data;
            for (const v of Object.values(dict)) {
              list.push({
                label: v.id,
                text: v.name,
                data: v.data
              });
            }
            this.templateCates = list;
          }
        });
    },
    getCombinationCates () {
      let datatype = {
        type: 8,
        // direction: this.TOOL.getOptimizedNum(),
        // style: this.StyleMsg
      };
      switch (this.combination) {
        case 'text':
          datatype.type = 16;
          break;
        case 'prop':
          datatype.type = 17;
          break;
        case 'shape':
          datatype.type = 15;
          break;
      }
      this.$http
        .get('/api/home/category', {
          params: datatype
        })
        .then(({ data: resData } = {}) => {
          let dataArray = resData.data;
          this.categories.business = [];
          for (let item in dataArray) {
            this.categories.business.push(dataArray[item]);
          }
          if (this.categories.business.length) {
            this.formData.categories = [];
            this.$emit('updataformData', this.formData);
            this.setCategories(this.categories.business[0].id);
          }
          this.$emit('updataformData', this.formData);
        });
    },
    getCategories_x () {
      let datatype = {
        type: 8,
        // direction: this.TOOL.getOptimizedNum(),
        style: this.StyleMsg
      };
      switch (this.TopnavMsg.transferData.type) {
        case 'combination':
          datatype.style = this.formData.labelStyle[0];
          switch (this.combination) {
            case 'text':
              datatype.type = 16;
              break;
            case 'prop':
              datatype.type = 17;
              break;
            case 'shape':
              datatype.type = 15;
              break;
          }
          break;
      }
      this.$http
        .get('/api/home/category', {
          params: datatype
        })
        .then(({ data: resData } = {}) => {
          let dataArray = resData.data;
          switch (this.TopnavMsg.transferData.type) {
            case 'combination':
              this.categories.business = [];
              for (let item in dataArray) {
                this.categories.business.push(dataArray[item]);
              }
              if (this.categories.business.length) {
                this.formData.categories = [];
                this.$emit('updataformData', this.formData);
                this.setCategories(this.categories.business[0].id);
              }
              break;
            default:
              for (let item in dataArray) {
                let itemData = dataArray[item];
                switch (itemData.name) {
                  case '商业':
                    this.categories.business = itemData.data;
                    break;
                  case '个人':
                    this.categories.personal = itemData.data;
                    break;
                }
              }
              this.formData.categories = [];
              this.$emit('updataformData', this.formData);
              this.setCategories(this.categories.business[0].id);
          }
          this.$emit('updataformData', this.formData);
        });
    },
    setCategories (data, el) {
      let target =
        (el || {}).target ||
        $('.form-field__content.combination').children()[0];
      let index = this.searchDataIndex(this.formData.categories, data);
      if (index == -1) {
        this.formData.categories.push(data);
        if (target) {
          target.classList.add('submitLabelActive');
        }
      } else {
        if (this.formData.categories.length > 1) {
          this.formData.categories.splice(index, 1);
          if (el) {
            el.target.classList.remove('submitLabelActive');
          }
        }
      }
      this.$emit('updataformData', this.formData);
    },
    searchDataIndex (arrayData, id) {
      let t = -1;
      for (let i = 0; i < arrayData.length; i++) {
        if (arrayData[i] == id) {
          console.log(i);
          t = i;
          return t;
        }
      }
      return t;
    },
    payTypeFS (name, i) {
      if (this.formData[name] == i) return;
      switch (name) {
        case 'payType':
          this.payType = i;
          switch (i) {
            case 1:
              this.$refs.payTypeBtnActive_two.classList.remove(
                'payTypeBtnActive'
              );
              this.$refs.payTypeBtnActive_one.classList.add('payTypeBtnActive');
              break;
            case 0:
              this.price = 0;
              this.formData.price = 0;
              this.$emit('updataformData', this.formData);
              this.$refs.payTypeBtnActive_two.classList.add('payTypeBtnActive');
              this.$refs.payTypeBtnActive_one.classList.remove(
                'payTypeBtnActive'
              );
              break;
          }
          break;
        case 'price':
          i = Math.round(i);
          i = i < 1 ? 0 : i > 100 ? 100 : i;
          this.price = i || '';
          break;
      }
      this.$emit('formDataFS', { name, data: i });
    },

    handleGames () {
      if (this.templateGames) {
        return;
      }
      let filtered = this.GameList.filter(v => v.type == 1) || [];
      let mapped = filtered.map(v => {
        return {
          ...v,
          checked: false
        };
      });
      this.templateGames = mapped;
    },

    getTagsPlaceholder (max) {
      return `填写标签便于检索，最多不超过${max}个，点击Enter隔开多个标签`;
    },

    onSelectTemplateCate (item, selectorLabel) {
      const listHasItem = this.templateSelectedCates.includes(item.label);
      if (listHasItem) return;
      this.templateSelectedCates.push(item.label);
      this.templateSelectedCates = [...this.templateSelectedCates];
      if (selectorLabel === 'level-1') {
        this.getTemplateChildCates(item.label);
      }
    },
    onRemoveTemplateCate (item, selectorLabel) {
      this.templateSelectedCates = this.templateSelectedCates.filter(v => v !== item.label);
      if (selectorLabel === 'level-1') {
        // delete this.childCateTable[item.label];
        const childCateTable = {};
        Object.keys(this.childCateTable).forEach(key => {
          if (key - 0 !== item.label) {
            childCateTable[key] = this.childCateTable[key];
          }
        });
        this.childCateTable = childCateTable;
      }
    },
    getTemplateCateText (label) {
      const cate = this.templateCates.find(v => v.label === label - 0);
      return cate && cate.text;
    },
    async getTemplateChildCates (label) {
      // const resp = await this.$http.get('/api/home/category', {
      //   params: {
      //     type: 8,
      //     categoryId: label
      //   }
      // });
      // const data = resp.data.data;
      const cate = this.templateCates.find(v => v.label === label) || {};
      const optionItems = cate.data.map(v => {
        return {
          label: v.id,
          text: v.name
        };
      });
      this.childCateTable = {
        ...this.childCateTable,
        [label]: {
          optionItems,
          selectedLabels: []
        }
      }
    },
    filterSelectedLabels (labels = [], optionItems = []) {
      return labels.filter(label => {
        return optionItems.some(item => item.label === label);
      })
    },
    onSelectTemplateChildCate (item, selectorLabel) {
      const {selectedLabels} = this.childCateTable[selectorLabel];
      const listHasItem = selectedLabels.includes(item.label);
      if (listHasItem) return;
      selectedLabels.push(item.label);
      this.$set(this.childCateTable[selectorLabel], 'selectedLabels', [...selectedLabels]);
    },
    onRemoveTemplateChildCate (item, selectorLabel) {
      const {selectedLabels} = this.childCateTable[selectorLabel];
      const filtered = selectedLabels.filter(v => v !== item.label);
      this.$set(this.childCateTable[selectorLabel], 'selectedLabels', filtered);
    },

    validateTemplateCates () {
      if (this.TopnavMsg.transferData.type !== 'template') {
        return true;
      }
      const cates = this.templateSelectedCates;
      const isEmpty = !cates || !cates.length;
      let isChildEmpty = true;
      // this.filterSelectedLabels(this.templateSelectedCates, this.templateCates);
      for (const key of Object.keys(this.childCateTable)) {
        const v = this.childCateTable[key];
        isChildEmpty = !v.optionItems.some(item => this.templateSelectedCates.includes(item.label));
        if (isChildEmpty) break;
      }
      const valid = !isEmpty && !isChildEmpty;
      return valid;
    },

    validateFields () {
      this.validateText({name: 'title'});
      const valid = this.validateTemplateCates();
      this.templateCatesFail = !valid;
    },

    async onViewShow () {
      this.validateFields();
      console.log(`turbo: onViewShow -> this`, this);
      await this.createStyleArrayMsg();
      if (this.StyleArrayMsg) {
        switch (this.TopnavMsg.transferData.type) {
          case 'combination':
            this.judgeFrom.label = false;
            this.judgeFrom.videoPrice = false;
            this.judgeFrom.videoCategories = false;
            this.judgeFrom.videoStyle = false;
            this.judgeFrom.combinationPrice = true;
            this.judgeFrom.combinationStyle = true;
            this.judgeFrom.combinationCategories = true;
            this.combinationStyle = this.StyleArrayMsg[0].id;
            this.combination = '';
            this.combination = 'text';
            this.formData.desc.value = '';
            this.formData.desc.placeholder =
              '简介可以展示关于组合的更多背景信息或内容哦';

            break;
          default:
            this.judgeFrom.label = true;
            this.judgeFrom.videoPrice = true;
            this.judgeFrom.videoCategories = true;
            this.judgeFrom.videoStyle = true;
            this.judgeFrom.combinationPrice = false;
            this.judgeFrom.combinationStyle = false;
            this.judgeFrom.combinationCategories = false;
            this.combinationStyle = '';
            // this.formData.desc.value =
            //   this.formData.title.value +
            //   '由来画动画提供,丰富MG动画素材,短视频制作模板,免费在线制作动画短视频。来画动画,中国首家短视频智能创作营销平台。';
            break;
        }

        this.setLabelStyle(this.StyleArrayMsg[0].id);
        this.$emit('updataformData', this.formData);
        this.getCategories();
      }
    },

    async createStyleArrayMsg () {
      let platform = this.templateType === 'app' ? 2 : void 0;
      const { data: resp } = await this.$http.get('/api/home/style', {
        params: {
          platform
        }
      });
      this.StyleArrayMsg = resp.data;
    }
  }
};
</script>

<style lang="scss" scoped>
.painterSubmit {
  display: flex;
  flex-wrap: wrap;
  height: auto;
  width: 527px;
  justify-content: left;
}
@import '../../../style/colors';
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: $c10;
}
.md40 {
  margin-bottom: 40px;
}
.md20 {
  margin-bottom: 20px;
}
.md10 {
  margin-bottom: 10px;
}

.form-field {
  display: flex;
  justify-content: center;
  align-items: center;

  &__title {
    position: relative;
    white-space: nowrap;
    font-weight: bold;
    &.is-top {
      margin-top: -38px;
    }
    &.is-required {
      &:before {
        content: ' ';
        position: absolute;
        right: -0.6em;
        top: -0.2em;
        width: 4px;
        height: 4px;
        border-radius: 4px;
        background-color: red;
      }
      &.template-child-cates:before {
        right: -2.1em;
      }
    }
  }
  &__content {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    flex-shrink: 0;
    margin-left: 28px;
    width: 527px;
  }
  &__tag {
    position: relative;
    display: flex;
    align-items: center;
    height: 40px;
    line-height: 40px;
    border-radius: 4px;
    background-color: $c2;
    margin-right: 8px;
    padding: 0 1em;
    color: $c0;
    transition-duration: 0.3s;
    margin-top: 5px;
    margin-bottom: 5px;

    > span {
      white-space: nowrap;
    }

    > .remove {
      display: inline-block;
      width: 1em;
      height: 1em;
      transform: translate(0.5em, 0);
    }
  }
  &__input {
    position: relative;
    width: 527px;
    height: 40px;
    border-radius: 4px;
    background-color: $c9;
    transition-duration: 0.3s;
    > input {
      width: 100%;
      height: 100%;
      padding-left: 1em;
      padding-right: 1em;
      border: none;
      background-color: transparent;
    }
  }
  &__textarea {
    position: relative;
    width: 527px;
    height: 80px;
    border-radius: 4px;
    background-color: $c9;
    > textarea {
      resize: none;
      width: 100%;
      height: 100%;
      border: none;
      background: transparent;
      padding: 1em;
    }
  }
  &__tip {
    position: absolute;
    bottom: 0.6em;
    right: 1em;
    color: $c10;
  }
  &__valid-tip {
    position: absolute;
    left: 1em;
    bottom: -17px;
    color: red;
    font-size: 12px;
  }
}

.form {
  &__cover-preview {
    $preview-box-width: 493px;
    $preview-box-width-2: 155px;
    $preview-box-height: 278px;
    position: relative;
    margin-left: auto;
    margin-right: auto;
    transform: translatex(11px);
    width: $preview-box-width;
    height: $preview-box-height;
    border: solid 1px $c6;
    overflow: hidden;

    > img {
      height: 100%;
    }

    > .watermark {
      position: absolute;
      right: 0; // $preview-box-width * 0.02;
      bottom: 0; // $preview-box-height * 0.02;
      width: 493px; // $preview-box-width * 0.6;
      height: 278px; // $preview-box-width * 0.6 * 927 / 1157;

      &.vertical-editor {
        right: 0; // 6px;
        bottom: 0; // 29px;
        width: 155px; // 155px * 0.9;
        height: 278px; // 155px * 0.9 * 927 / 1157;
      }
      > img {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 100%;
      }
    }

    > .watermark--default {
      > i {
        // width: $preview-box-width * 0.13;
        // height: $preview-box-width * 0.13 * 58 / 103;
        width: $preview-box-width * 0.25;
        // height: $preview-box-width * 0.25 / 2.5;
        height: $preview-box-width * 0.25 * 927 / 1157;
        position: absolute;
        right: 0;
        bottom: 0;

        &.vertical-editor {
          width: $preview-box-width-2 * 0.25;
          // height: $preview-box-width-2 * 0.25 / 2.5;
          height: $preview-box-width-2 * 0.25;
        }
      }
    }

    > .btn {
      position: absolute;
      right: 10px;
      bottom: 10px;
      width: 60px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background-color: $c0;
      border: 1px solid $c3;
      border-radius: 4px;
      color: $c3;
      box-shadow: 0 0 3px 0 rgba($c3, 0.3);
      cursor: pointer;

      &:hover {
        color: $c2;
        border-color: $c2;
      }
    }
  }
}

.cover-picker {
  width: 527px;
  > ul {
    display: flex;
    align-items: center;
    > li {
      width: 100px;
      height: 57px;
      box-sizing: border-box;
      border: 1px solid $c6;
      margin-right: 8px;

      > img {
        height: 100%;

        &.is-selected {
          box-shadow: 0 0 0 2px $c2;
        }
      }

      &.is-selected {
        border: 1px solid $c2;
        box-shadow: 0 0 0 1px $c2;
      }

      &.is-add {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 70px;
        height: 50px;
        border-radius: 4px;
        margin-left: 24px;
        background-color: $c9;
        cursor: pointer;
        > .my-icon-add {
          position: relative;
          display: inline-block;
          width: 18px;
          height: 18px;
          color: $c2;
          &:before {
            position: absolute;
            left: 0;
            top: 50%;
            content: ' ';
            height: 2px;
            width: 100%;
            margin-top: -1px;
            background-color: $c2;
          }

          &:after {
            position: absolute;
            top: 0;
            left: 50%;
            content: ' ';
            height: 100%;
            width: 2px;
            margin-left: -1px;
            background-color: $c2;
          }
        }
        > .el-icon-edit {
          &:before {
            color: $c2;
          }
        }
      }
    }
  }
}

.radios {
  > ul {
    display: flex;
    justify-content: space-between;
    align-items: center;
    > li {
      position: relative;
      width: 200px;
    }
  }
}
.radio {
  display: inline-block;
  display: flex;
  align-items: center;
  cursor: pointer;

  &__shape {
    // display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    width: 16px;
    height: 16px;
    border: 2px solid $c2;
    border-radius: 16px;

    &.is-active {
      box-shadow: 0 0 0 2px $c0 inset;
      background-color: $c2;
    }
  }
  &__label {
    display: flex;
    margin-left: 1.2em;
  }
  &__tip {
    position: absolute;
    bottom: 0;
    left: 0;
    transform: translatey(150%);
    color: $c2;
    white-space: nowrap;
  }
}

.submit {
  width: 160px;
  height: 40px;
  margin: auto;
  border-radius: 8px;
  color: $c0;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}

.mark {
  box-sizing: border-box;
  min-width: 30px;
  height: 18px;
  font-size: 12px;
  line-height: 18px;
  background-color: $c11;
  color: $c0;
  margin-left: 8px;
  border-radius: 4px;
  padding: 0 4px;
}

.small-btn {
  display: inline-block;
  width: 3em;
  height: 1.5em;
  line-height: 1.5em;
  border-radius: 4px;
}
.ml {
  margin-left: 1em;
}

.submitLabel {
  padding: 0 10px;
  line-height: 40px;
  margin-right: 5px;
  margin-bottom: 5px;
  cursor: pointer;
  min-width: 100px;
  height: 40px;
  background-color: #f8f8fc;
  border-radius: 4px;
  border: solid 1px #ddd9eb;
}
.submitLabelActive {
  background-color: #ececfb;
  border-radius: 4px;
  border: solid 1px #5778fb;
}
.payTypeBtn {
  position: relative;
  display: inline-block;
  width: 16px;
  height: 16px;
  border: solid 2px #5778fb;
  border-radius: 100%;
  cursor: pointer;
  vertical-align: sub;
}
.payTypeBtnActive {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 8px;
  height: 8px;
  background-color: #5778fb;
  border-radius: 100%;
}
.submitLabelTitle {
  position: absolute;
  top: 0px;
  left: 0;
}

.template-game {
  display: block;
}
.template-game-item {
  text-align: left;
  height: 38.5px;
  line-height: 38.5px;
}
.template-game-container {
  align-items: flex-start;
  height: 38.5px;
  line-height: 38.5px;
}
.template-game-link {
  color: #5778fb;
  &:visited {
    color: #5778fb;
  }
}

.child-cate-row {
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  & > .child-cate-text {
    margin-left: 4px;
    margin-right: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/exportDialog/painterSubmit.vue